import { Avatar, Grid, Typography } from '@mui/material';
import { lighten, useTheme } from '@mui/material/styles';
import gender from 'common/constants/gender';
import { format } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';
import { capitalize, first, pick, trim } from 'lodash';
import PropTypes from 'prop-types';
import { shallowEqual, useSelector } from 'react-redux';
import stc from 'string-to-color';

const PatientBanner = ({ mpi, firstName, lastName, dob, email, status, gender: genderProp }) => {
  const theme = useTheme();
  const storePatientInfo = useSelector(
    ({ patient }) =>
      pick(patient[mpi], 'firstName', 'lastName', 'status', 'email', 'dob', 'gender'),
    shallowEqual
  );

  const patientInfo = {
    firstName: firstName || storePatientInfo?.firstName,
    lastName: lastName || storePatientInfo?.lastName,
    dob: dob || storePatientInfo?.dob,
    email: email || storePatientInfo?.email,
    gender: genderProp || storePatientInfo?.gender,
    status: status || storePatientInfo?.status,
  };

  const fullName =
    patientInfo?.firstName &&
    trim(`${patientInfo?.lastName}${patientInfo?.lastName ? ',' : ''} ${patientInfo?.firstName}`);

  const avatarBgColor =
    patientInfo?.firstName && stc(`${fullName}${patientInfo.dob}${patientInfo.email}`);

  const initials =
    `${capitalize(first(patientInfo?.firstName))}${capitalize(first(patientInfo?.lastName))}` ||
    undefined;

  return (
    <Grid
      item
      xs={12}
      sx={{
        display: 'flex',
        bgcolor: lighten(theme.palette.primary.light, 0.8),
        py: 1,
        borderRadius: '4px',
      }}
    >
      <Grid item sx={{ ml: 2 }}>
        <Avatar
          sx={{
            bgcolor: avatarBgColor,
            color: theme.palette.getContrastText(avatarBgColor || '#000'),
            width: theme.spacing(6),
            height: theme.spacing(6),
            fontSize: '1.5em',
            letterSpacing: '0.1rem',
            m: 'auto',
          }}
          alt={patientInfo?.firstName}
        >
          {initials}
        </Avatar>
      </Grid>

      <Grid item sx={{ ml: 3 }} justifyItems='center' alignContent='center'>
        <Grid>
          <Typography>
            {patientInfo?.lastName}, {patientInfo?.firstName}
          </Typography>
        </Grid>
        <Grid>
          <Typography>
            {patientInfo?.dob
              ? `${format(utcToZonedTime(new Date(patientInfo.dob), 'utc'), 'MM/dd/yyyy')}, ${gender[patientInfo?.gender] || ''}`
              : gender[patientInfo?.gender] || ''}
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
};

PatientBanner.propTypes = {
  mpi: PropTypes.string.isRequired,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  dob: PropTypes.string,
  email: PropTypes.string,
  status: PropTypes.string,
  gender: PropTypes.string,
};

PatientBanner.defaultProps = {
  firstName: undefined,
  lastName: undefined,
  dob: undefined,
  email: undefined,
  status: undefined,
  gender: undefined,
};

export default PatientBanner;
